export const ALL_STORIES_ID = 'all_stories';
